import { render, staticRenderFns } from "./ModalCadastraFolhaDePonto.vue?vue&type=template&id=69289738"
import script from "./ModalCadastraFolhaDePonto.vue?vue&type=script&lang=js"
export * from "./ModalCadastraFolhaDePonto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports